export default __webpack_public_path__ + "static/media/Client Logos – 01 – ArtStation.f9792036.svg";